var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"[ o-list-bare__item ] [ c-arrow-sublist__item ]"},[_c('PRGLink',{attrs:{"url":_vm.url}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.flatPackageProductGroup.name))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }